// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { FileItem } from './file-item';
import { FinalDocumentShortProtocol } from './final-document-short-protocol';

/**
 * 
 * @export
 * @interface FinalDocumentShort
 */
export interface FinalDocumentShort {
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    id: string;
    /**
     * 
     * @type {FinalDocumentShortProtocol}
     * @memberof FinalDocumentShort
     */
    protocol?: FinalDocumentShortProtocol;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    internship?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    graduateWork?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    assignedQualificationRank?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    educationalRelations?: string;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocumentShort
     */
    issuedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocumentShort
     */
    expiration?: Date;
    /**
     * 
     * @type {number}
     * @memberof FinalDocumentShort
     */
    formOfEducation?: number;
    /**
     * 
     * @type {number}
     * @memberof FinalDocumentShort
     */
    sourceOfFinance?: number;
    /**
     * 
     * @type {number}
     * @memberof FinalDocumentShort
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    certificateSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    registerNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    educationDocument?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    series?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    originalSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    originalNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    originalRegisterNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    originalIssuedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    recipientName?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    recipientMiddleName?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    recipientLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    documentNumberToChange?: string;
    /**
     * 
     * @type {number}
     * @memberof FinalDocumentShort
     */
    confirmOfLoss?: number;
    /**
     * 
     * @type {number}
     * @memberof FinalDocumentShort
     */
    confirmOfExchange?: number;
    /**
     * 
     * @type {Array<FileItem>}
     * @memberof FinalDocumentShort
     */
    files?: Array<FileItem>;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    activityArea?: string;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocumentShort
     */
    signedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocumentShort
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocumentShort
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    listenerId?: string;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocumentShort
     */
    fisFrdoExportedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FinalDocumentShort
     */
    fisFrdoType?: FinalDocumentShortFisFrdoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FinalDocumentShort
     */
    isFisFrdoExported: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum FinalDocumentShortFisFrdoTypeEnum {
    ProfessionalEducation = 'professional.education',
    AdditionalProfessionalEducation = 'additional.professional.education'
}



